import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SystemSetting } from '../../viewmodels/configuration/system-setting';
import { BackendService } from '../backend.service';
import { CONFIG } from '../config';

@Injectable({
  providedIn: 'root',
})
export class SystemConfigurationService {
  constructor(private backendService: BackendService) {}

  public getConfigurationValue(name: string): Observable<string> {
    return this.backendService.getAnyById(CONFIG.apiRoutes.systemConfiguration, name);
  }

  public getAllSystemConfigurationSettings(): Observable<SystemSetting[]> {
    return this.backendService.getAll(SystemSetting);
  }
}
